import React, { useEffect, useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { LearningSection } from './components/LearningSection';
import { MidPageCTA } from './components/MidPageCTA';
import { BenefitsSection } from './components/BenefitsSection';
import { AudienceSection } from './components/AudienceSection';
import { FormatSection } from './components/FormatSection';
import { SalesLetterSection } from './components/SalesLetterSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
import { UpsellPage } from './pages/UpsellPage';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  useEffect(() => {
    initMetaPixel();
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);
  if (currentPath === '/upsell') {
    return <UpsellPage data-id="element-0" />;
  }
  return <main className="min-h-screen w-full font-sans selection:bg-[#FFD166]/40 selection:text-[#2F3A3D] relative" data-id="element-1">
      {/* Global Background Image */}
      <div className="fixed inset-0 -z-10" data-id="element-2">
        <img src="https://cdn.magicpatterns.com/uploads/imvn1P5XeaM4CxtYvFkxAZ/ChatGPT_Image_14_mar_2026,_12_14_19_a.m..png" alt="" className="w-full h-full object-cover" data-id="element-3" />
        <div className="absolute inset-0 bg-[#F7F3E9]/75" data-id="element-4"></div>
      </div>
      <HeroSection data-id="element-5" />
      <SalesLetterSection data-id="element-6" />
      <ProblemSection data-id="element-7" />
      <SolutionSection data-id="element-8" />
      <MidPageCTA data-id="element-9" />
      <LearningSection data-id="element-10" />
      <BenefitsSection data-id="element-11" />
      <AudienceSection data-id="element-12" />
      <FormatSection data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </main>;
}